import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { ErrorCode } from '../hosted-web-content-sdk.interface';
import { DevicePermission, } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { createSdkError, formulateSdkResponse, onSdkError } from './messageHandlingUtils';
import { verifyDevicePermissions } from './messageHandlingUtils';
var mapNotSupported = 'location.map is not supported on this host.';
/**
 * Responsible for location module related message requests.
 */
var LocationMessageHandler = /** @class */ (function (_super) {
    __extends(LocationMessageHandler, _super);
    function LocationMessageHandler(appSdkHost, permissionsService, locationService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.permissionsService = permissionsService;
        _this.locationService = locationService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    LocationMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.location.getCurrentLocation, function (_, locationProps) { return _this.handleGetCurrentLocation(locationProps); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.location.getCurrentLocation, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.location.map.showLocation, function (_, params) {
            return _this.handleShowLocation(params);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.location.map.showLocation, error, scenario); },
        });
    };
    LocationMessageHandler.prototype.handleShowLocation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.locationService.mapService) {
                    return [2 /*return*/, formulateSdkResponse(params, this.locationService.mapService.showLocation)];
                }
                else {
                    throw createSdkError(ErrorCode.INTERNAL_ERROR, mapNotSupported);
                }
                return [2 /*return*/];
            });
        });
    };
    LocationMessageHandler.prototype.handleGetCurrentLocation = function (locationProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyDevicePermissions(this.permissionsService, DevicePermission.GeoLocation)];
                    case 1:
                        _a.sent();
                        if (!locationProps.allowChooseLocation && !locationProps.showMap) {
                            return [2 /*return*/, formulateSdkResponse(locationProps, this.locationService.getCurrentLocation)];
                        }
                        if (this.locationService.mapService) {
                            return [2 /*return*/, this.handleGetLocationServiceInMap(locationProps)];
                        }
                        else {
                            throw createSdkError(ErrorCode.INTERNAL_ERROR, mapNotSupported);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationMessageHandler.prototype.validateDependencies = function () {
        if (!this.locationService) {
            throw 'No locationService provided';
        }
        if (!this.permissionsService) {
            throw 'LocationService is provided but no permissionsService is provided';
        }
    };
    LocationMessageHandler.prototype.handleGetLocationServiceInMap = function (locationProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!locationProps.allowChooseLocation && locationProps.showMap) {
                    return [2 /*return*/, formulateSdkResponse(null, this.locationService.mapService.getCurrentLocationOnMap)];
                }
                else {
                    return [2 /*return*/, formulateSdkResponse(null, this.locationService.mapService.chooseLocation)];
                }
                return [2 /*return*/];
            });
        });
    };
    return LocationMessageHandler;
}(BaseMessageHandler));
export { LocationMessageHandler };
//# sourceMappingURL=location-message-handler.js.map